const VisitorOverview = ({
  data,
  title = "Visitor Overview",
  fields = { total: "totalVisitorCount", week: "weekCount", month: "monthCount", year: "yearCount" },
}) => {
  const items = [
    {
      label: "Total Visitor",
      value: data?.[fields.total],
      icon: "T",
      bg: "bg-purple-light",
    },
    {
      label: "Last 7 Week",
      value: data?.[fields.week],
      icon: "W",
      bg: "bg-blue-light",
    },
    {
      label: "This Month",
      value: data?.[fields.month],
      icon: "M",
      bg: "bg-green-light",
    },
    {
      label: "This Year",
      value: data?.[fields.year],
      icon: "Y",
      bg: "bg-orange-light",
    },
  ];

  return (
    <div className="visitor-card h-100">
      <h6 className="fw-bold mb-3">{title}</h6>

      <div className="d-flex flex-column gap-2">
        {items.map((item, index) => (
          <div className="visitor-item" key={index}>
            <div className="left">
              <div className={`icon-circle ${item.bg}`}>
                {item.icon}
              </div>
              <span>{item.label}</span>
            </div>
            <span className="value">{item.value || 0}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VisitorOverview;
